import React, { Component } from 'react';
import Icon from './Icon.js';
import './Svg.scss';
import './Icon.scss';

export default class ExpandIcon extends Component {
    render () {
        let finalClassName = Icon.buildCssClass(this.props);

        return (
            <svg className={finalClassName} width="24" height="24" viewBox="0 0 24 24">
                <path d="M9.997 9.553L.964.167a.55.55 0 0 0-.801 0 .604.604 0 0 0 0 .833l9.436 9.802a.548.548 0 0 0 .8 0L19.831 1a.605.605 0 0 0 .167-.415c0-.147-.054-.3-.167-.413a.55.55 0 0 0-.802 0L9.997 9.553z"/>
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/icon/Expand.js